import { render } from "./answer.vue?vue&type=template&id=a9f3715a&scoped=true"
import script from "./answer.vue?vue&type=script&lang=js"
export * from "./answer.vue?vue&type=script&lang=js"

import "./answer.vue?vue&type=style&index=0&id=a9f3715a&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9f3715a"]])

export default __exports__